


































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import {requestFullThree} from '@api/nodeApi';
import router from '@/router';
import {Can} from '@casl/vue';
import Loading from '@c/controls/Loading.vue';
import {
  DevicesType,
  GuidDataType,
  HeaterStatus,
  MachineItemType,
  measurementsItemType,
  ModuleItemType,
  SensorDataInterface,
  SensorMeasurementsType,
  SensorTypeItem,
  SensorTypeTransform,
  UpdateDataTableInterface,
  UpdateSensorDataWSInterface,
} from '@v/services/sensorReadings/sensorReading.interface';
import {httpClient} from '@api/baseApi';
import {getDateWithTime} from '@u/dateTimeUtils';
import {connectionSensors} from '@api/configApi';
import FacilityStructureTreeHelp from '@v/dashboard/FacilityStructureTreeHelp.vue';
import SimpleDialog from '@c/SimpleDialog.vue';
import DateTimePicker from '@c/controls/DateTimePicker.vue';
import {nodeStatusColorScheme} from '@/components/system/configurate';
import {PModuleType} from '@e/configs';

@Component({
  computed: {
    HeaterStatus() {
      return HeaterStatus;
    },
  },
  methods: {getDateWithTime},
  components: {
    FacilityStructureTreeHelp,
    SimpleDialog,
    DateTimePicker,
    Can,
    Loading,
  },
})
export default class SensorReadings extends Vue {
  tableData: MachineItemType[] = [];
  items: MachineItemType[] = [];
  filterItems: MachineItemType[] = [];
  isFetching = false;
  sensorData: SensorDataInterface = [];
  listIdGuid: GuidDataType = {};
  socket!: WebSocket | null;
  updateData: UpdateDataTableInterface = {};
  sensorMeasurements: SensorMeasurementsType = {};
  archiveDialog = false;
  formValid = false;
  initArchiveTS: number | null = null;

  tooltipColorText = {
    [nodeStatusColorScheme.topErrorBoundary]: 'Превышен порог ошибки: ',
    [nodeStatusColorScheme.bottomErrorBoundary]: 'Значение ниже порога ошибки: ',
    [nodeStatusColorScheme.topDangerBoundary]: 'Превышен порог опасности:  ',
    [nodeStatusColorScheme.topWarningBoundary]: 'Превышен порог предупреждения: ',
    [nodeStatusColorScheme.bottomWarningBoundary]: 'Значение ниже порога предупреждения: ',
    [nodeStatusColorScheme.bottomDangerBoundary]: 'Значение ниже порога опасности: ',
    ['unset']: 'Значение: ',
  };

  async created() {
    this.isFetching = true;
    this.initArchiveTS = Date.now();

    const {data: measurementsList} = await httpClient.get(`/module_type_measurements/`);

    const {data} = await httpClient.get<ModuleItemType[]>(`modules/sensors/`);

    this.items = await requestFullThree().finally(() => {
      this.isFetching = false;
    });

    if (data && data.length) {
      data
        .filter(item =>
          [
            PModuleType.DtcpTemperatureModule,
            PModuleType.DtcpAccelerometerModule,
            PModuleType.DtcpTahoModule,
            PModuleType.DtcpEnergyModule,
          ].includes(item.type),
        )
        .forEach((item: ModuleItemType) => {
          if (item.nodes?.length) {
            if (
              [
                PModuleType.DtcpTemperatureModule,
                PModuleType.DtcpTahoModule,
                PModuleType.DtcpEnergyModule,
              ].includes(item.type) &&
              item.values
            ) {
              Object.keys(item.values).forEach(key => {
                this.sensorMeasurements[key] = item.measurements.reduce(
                  (acc, obj) => ({...acc, ...obj}),
                  {},
                );
              });
            }

            item.nodes.forEach(node => {
              this.listIdGuid[node.node_id] = this.listIdGuid[node.node_id]
                ? [...this.listIdGuid[node.node_id], item.guid]
                : [item.guid];

              if (this.sensorData[node.node_id]) {
                for (const sensorKey in item.values) {
                  const sensor: any = item.values[sensorKey as keyof typeof item.values];
                  sensor.uuid = item.guid;
                }

                if (item.values)
                  this.sensorData[node.node_id] = {
                    ...this.sensorData[node.node_id],
                    ...item.values,
                    vel: item.values.vel
                      ? [...this.sensorData[node.node_id].vel, item.values.vel]
                      : this.sensorData[node.node_id].vel,
                    rms: item.values.rms
                      ? [...this.sensorData[node.node_id].rms, item.values.rms]
                      : this.sensorData[node.node_id].rms,
                    temp: item.values.temp
                      ? [...this.sensorData[node.node_id].temp, item.values.temp]
                      : this.sensorData[node.node_id].temp,
                    taho: item.values.taho
                      ? [...this.sensorData[node.node_id].taho, item.values.taho]
                      : this.sensorData[node.node_id].taho,
                    amp: item.values.amp
                      ? [...this.sensorData[node.node_id].amp, item.values.amp]
                      : this.sensorData[node.node_id].amp,
                    heater: item.values.heater
                      ? [...this.sensorData[node.node_id].heater, item.values.heater]
                      : this.sensorData[node.node_id].heater,
                  };
              } else {
                if (item.values)
                  this.sensorData[node.node_id] = {
                    ...item.values,
                    vel: item.values.vel ? [item.values.vel] : [],
                    rms: item.values.rms ? [item.values.rms] : [],
                    temp: item.values.temp ? [item.values.temp] : [],
                    taho: item.values.taho ? [item.values.taho] : [],
                    amp: item.values.amp ? [item.values.amp] : [],
                    heater: item.values.heater ? [item.values.heater] : [],
                  };
              }
            });
          }
        });
    }

    measurementsList?.forEach((item: measurementsItemType & {alias: string}) => {
      if (['rms_x', 'rms_y', 'rms_z', 'vel_x', 'vel_y', 'vel_z'].includes(item.alias)) {
        this.sensorMeasurements[item.alias] = item;
      }
    });
    this.socket = connectionSensors();
  }

  findHeaterVal(data: UpdateDataTableInterface, item: MachineItemType) {
    if (data && item && item.guid && data[item.guid] && data[item.guid].heater) {
      return data[item.guid].heater.val ?? 0;
    }
    return 0;
  }

  findGuidItem(item: MachineItemType) {
    const modules = item.services_scheme?.flatMap(module => module.modules ?? []) ?? [];
    const guids = modules.flatMap(subModule => subModule.guids ?? []);
    return guids.find(gui => gui);
  }

  getColorCell(key: string, value: number) {
    const sensor: measurementsItemType = this.sensorMeasurements[key];

    if (sensor.top_error_boundary !== null && value > sensor.top_error_boundary)
      return nodeStatusColorScheme.topErrorBoundary;

    if (sensor.bottom_error_boundary !== null && value < sensor.bottom_error_boundary)
      return nodeStatusColorScheme.bottomErrorBoundary;

    if (
      sensor.top_danger_boundary !== null &&
      sensor.top_error_boundary !== null &&
      value > sensor.top_danger_boundary &&
      value <= sensor.top_error_boundary
    )
      return nodeStatusColorScheme.topDangerBoundary;

    if (
      sensor.top_warning_boundary !== null &&
      sensor.top_danger_boundary !== null &&
      value > sensor.top_warning_boundary &&
      value <= sensor.top_danger_boundary
    )
      return nodeStatusColorScheme.topWarningBoundary;

    if (
      sensor.bottom_danger_boundary !== null &&
      sensor.bottom_warning_boundary !== null &&
      value > sensor.bottom_danger_boundary &&
      value <= sensor.bottom_warning_boundary
    )
      return nodeStatusColorScheme.bottomWarningBoundary;

    if (
      sensor.bottom_error_boundary !== null &&
      sensor.bottom_danger_boundary !== null &&
      value > sensor.bottom_error_boundary &&
      value <= sensor.bottom_danger_boundary
    )
      return nodeStatusColorScheme.bottomDangerBoundary;

    return 'unset';
  }

  @Watch('items')
  onChangeItems(data: MachineItemType[]) {
    const temp: MachineItemType[] = [];
    function getMachineLevel(item: MachineItemType) {
      if (item.type === DevicesType.Machine) {
        temp.push(item);
      } else if (item.children && item.children.length) {
        item.children.forEach(node => {
          getMachineLevel(node);
        });
      }
    }

    if (data && data.length) {
      data.forEach(item => {
        getMachineLevel(item);
      });
    }

    temp.forEach(item => {
      if (item.children && item.children.length) {
        const childrenLevelOne = item.children.filter(child => child.type === DevicesType.Node);

        if (childrenLevelOne.length) {
          childrenLevelOne.forEach(node => {
            if (node.children && node.children.length) {
              node.children = node.children.filter(
                (subNone: MachineItemType) => subNone.type === DevicesType.Node,
              );
            }
          });
        }
        item.children = childrenLevelOne;
      }
    });
    this.filterItems = temp;
  }

  @Watch('filterItems')
  onChangeFilterItems(data: MachineItemType[]) {
    if (data) {
      let row = 3; // со второй строки в таблице начинаюются данные (0 и 1 заголовки)
      const tempData = [...data];

      tempData?.forEach(item => {
        // станок
        item.row = row;
        item.guid = this.findGuidItem(item);

        if (item.children && item.children.length) {
          // Механизм
          item.children.forEach((node: MachineItemType) => {
            node.row = row;
            node.guid = this.findGuidItem(node);
            const shiftRow = node.children?.length ? node.children.length : 1;
            node.sensors = this.getSensorData(node.id);

            if (node.children && node.children.length) {
              // Агрегат
              node.children.forEach((subNode: MachineItemType, idxSubNode: number) => {
                subNode.row = node.row + idxSubNode;
                subNode.span = 1;
                subNode.guid = this.findGuidItem(subNode);
                subNode.sensors = this.getSensorData(subNode.id);
              });
            } else {
              node.children = [
                {name: '', row: node.row, span: 1, sensors: {}, guid: undefined, heater: 0},
              ];
            }
            node.span = shiftRow;
            row = row + shiftRow;
          });
        } else {
          item.span = 1;
          item.children = [
            {
              id: Math.random() * 100,
              row: item.row,
              span: 1,
              name: '',
              children: [
                {
                  id: Math.random() * 100,
                  row: item.row,
                  span: 1,
                  name: '',
                  sensors: {},
                  guid: undefined,
                  heater: 0,
                },
              ],
            },
          ];
          row = row + 1;
        }
        item.span = row - item.row;
      });
      this.tableData = tempData;
    }
  }

  @Watch('tableData')
  onLoadSensorData() {
    if (this.socket) {
      this.socket.onmessage = (e: {data: string}) => {
        this.updateData = {};
        if (e.data) {
          const dataWS = JSON.parse(e.data);
          const values: UpdateSensorDataWSInterface[] = JSON.parse(dataWS.data.values);
          if (values && values.length) {
            values.forEach(item => {
              this.updateData[item.uuid] = item;
            });
          }
        }
      };
    }
  }

  @Watch('updateData')
  updateTableData(data: UpdateDataTableInterface) {
    const temp: MachineItemType[] = [...this.tableData];
    const getRefreshSensorsData = (node: MachineItemType) => {
      const guidNode = this.listIdGuid[node.id];
      const oldSensors: any = {...node.sensors};

      if (guidNode && guidNode.length) {
        const newSensors: SensorTypeTransform = {
          vel: [],
          rms: [],
          temp: [],
          taho: [],
          amp: [],
          heater: [],
        };

        guidNode.forEach(item => {
          const {vel, rms, temp, taho, amp} = data[item] || {};
          newSensors.vel = vel ? [...newSensors.vel, vel] : newSensors.vel;
          newSensors.rms = rms ? [...newSensors.rms, {...rms, uuid: item}] : newSensors.rms;
          newSensors.temp = temp ? [...newSensors.temp, temp] : newSensors.temp;
          newSensors.taho = taho ? [...newSensors.taho, taho] : newSensors.taho;
          newSensors.amp = amp ? [...newSensors.amp, amp] : newSensors.amp;
        });

        const updateOldSensor = (key: keyof SensorTypeTransform) => {
          return oldSensors[key].map((item: SensorTypeItem) => {
            const matchingNewSen = (newSensors[key] as SensorTypeItem[]).find(
              (sen: SensorTypeItem) => sen.uuid === item.uuid,
            );
            if (matchingNewSen !== undefined) {
              return {
                ...item,
                ...matchingNewSen,
              };
            }
            return item;
          });
        };

        Object.keys(newSensors).forEach(key => {
          const sensorKey = key as keyof SensorTypeTransform;
          if (
            newSensors[sensorKey]?.length < oldSensors[sensorKey]?.length &&
            oldSensors[sensorKey]?.length > 1
          ) {
            newSensors[sensorKey] = updateOldSensor(sensorKey);
          }
        });

        return {
          ...newSensors,
          ...(!newSensors.vel?.length && {vel: oldSensors.vel}),
          ...(!newSensors.rms?.length && {rms: oldSensors.rms}),
          ...(!newSensors.temp?.length && {temp: oldSensors.temp}),
          ...(!newSensors.taho?.length && {taho: oldSensors.taho}),
          ...(!newSensors.amp?.length && {amp: oldSensors.amp}),
        };
      }

      return oldSensors;
    };

    temp.forEach(item => {
      item.heater = this.findHeaterVal(data, item);

      if (item.children && item.children.length) {
        // Механизм
        item.children.forEach((node: MachineItemType) => {
          const guidNode = this.listIdGuid[node.id];

          if (guidNode && guidNode.length) {
            node.sensors = getRefreshSensorsData(node);
            node.heater = this.findHeaterVal(data, node);

            // Обновление датчиков агрегата
            if (node.children && node.children.length) {
              node.children.forEach(subNode => {
                if (subNode && subNode.id) {
                  subNode.heater = this.findHeaterVal(data, subNode);
                  subNode.sensors = getRefreshSensorsData(subNode);
                }
              });
            }
          }
        });
      }
    });
    this.tableData = temp;
  }
  getSensorData(id: number) {
    return this.sensorData[id] ?? {};
  }

  beforeDestroy() {
    if (this.socket) {
      this.closeConnection(this.socket);
    }
  }

  closeConnection(socket: WebSocket | null) {
    if (socket) {
      socket.close();
      socket = null;
    }
  }

  back() {
    router.push('/');
  }

  onClickNode(id: number) {
    const {href} = this.$router.resolve({name: 'node', params: {id: id.toString()}});
    window.open(href, '_blank');
  }

  onClickNodeView(id: number) {
    const {href} = this.$router.resolve({name: 'nodeSensorsView', params: {id: id.toString()}});
    window.open(href, '_blank');
  }

  setArchiveTS(value: number) {
    this.initArchiveTS = value;
  }

  async exportArchiveReadings() {
    const resp = await httpClient.get('services/exports/sensors_snapshot/', {
      responseType: 'arraybuffer',
      params: {timestamp: this.initArchiveTS},
    });
    const filename = resp.headers['content-disposition']
      ? resp.headers['content-disposition'].match(/"([^"]+)"/)[1]
      : 'sensors_' +
        new Date()
          .toISOString()
          .replace(/[^0-9]/g, '_')
          .substring(0, 19) +
        '.xlsx';
    const binstr = Array.from(new Uint8Array(resp.data), byte => String.fromCodePoint(byte)).join(
      '',
    );
    const link = document.createElement('a');
    link.download = filename;
    link.href =
      'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' +
      btoa(binstr);
    link.click();
  }

  async exportReadings() {
    const resp = await httpClient.get('services/exports/sensors_snapshot/', {
      responseType: 'arraybuffer',
    });
    const filename = resp.headers['content-disposition']
      ? resp.headers['content-disposition'].match(/"([^"]+)"/)[1]
      : 'sensors_' +
        new Date()
          .toISOString()
          .replace(/[^0-9]/g, '_')
          .substring(0, 19) +
        '.xlsx';
    const binstr = Array.from(new Uint8Array(resp.data), byte => String.fromCodePoint(byte)).join(
      '',
    );
    const link = document.createElement('a');
    link.download = filename;
    link.href =
      'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' +
      btoa(binstr);
    link.click();
  }
}
